'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'
import { IFounder } from '@/interfaces/founders'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import { Founder } from './founder'
import style from './founders.module.scss'

interface InstitutionsProps extends HTMLProps<HTMLDivElement> {
  title: string
  items: IFounder[]
}

export const Founders = (props: InstitutionsProps) => {
  const { className, title, items } = props
  const { ref: innerRef, animate } = useAppearance()

  return (
    <motion.section
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, 'main-padding', className)}
    >
      <Text className={style.title} color="dark" type="h2" tagName="h3">
        {title}
      </Text>

      <ul className={style.list}>
        {items.map((item, index) => {
          return <Founder className={style.item} key={index} {...item} />
        })}
      </ul>
    </motion.section>
  )
}
